import UptimeInlineLatency from "@/v2-backoffice-client/uptime/inline/UptimeInlineLatency"
import { useLayerUptimeTarget } from "@/v2-backoffice-client/layer/view/layer.view.uptime.hooks"

export type LayerViewUptimeLatencyProps = {
  featureCode: string
  isProbing?: boolean
}

/** The layer sheet's "Response time" info item: 24h latency sparkline + average. */
function LayerViewUptimeLatency(props: LayerViewUptimeLatencyProps) {
  const { featureCode, isProbing } = props
  const { target, isLoading } = useLayerUptimeTarget({ featureCode, isProbing })

  return <UptimeInlineLatency target={target} loading={isLoading} />
}

export default LayerViewUptimeLatency
